import { cva } from 'class-variance-authority';

export type SwitchVariant = 'default';

export type SwitchSize = 'default';

export const SwitchVariants = cva(
  'peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        default: [
          'data-[state=checked]:bg-positive',
          'data-[state=unchecked]:bg-switch-thumb-unchecked',
          'disabled:data-[state=checked]:bg-positive/30',
          'disabled:data-[state=unchecked]:bg-switch-thumb-unchecked/30',
        ],
      },
      size: {
        default: 'h-2.5 w-6',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

export const ThumbVariants = cva(
  'pointer-events-none block rounded-full bg-switch-ball data-[disabled]:bg-switch-thumb-unchecked shadow-md ring-0 transition-transform data-[state=unchecked]:-translate-x-1',
  {
    variants: {
      variant: {
        default: 'bg-switch-ball',
      },
      size: {
        default: 'w-4 h-4 data-[state=checked]:translate-x-3',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);
